import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Text } from 'src/Components'

const propTypes = {
  listing: PropTypes.shape({
    source: PropTypes.shape({
      name: PropTypes.string,
    }),
  }),
}

const NmlsInfo = ({ listing }) => {
  if (!listing.source?.name) {
    return null
  }

  return (
    <Text element='span' size='xxs' variant='neutralCool' variantCount='500'>
      <FormattedMessage
        id='HomeSearch.listingDetails.nmls.providedBy'
        defaultMessage='Listing provided/courtesy of {source}'
        values={{
          source: listing.source.name,
        }}
      />
    </Text>
  )
}

NmlsInfo.propTypes = propTypes

export default NmlsInfo
